enum EnumPaymentMethod {
    CC = "CC", 
    ATM = "ATM", 
    CVS = "CVS", 
    PayPal = "PayPal", 
    OnSite = "OnSite", 
}

export default EnumPaymentMethod